'use strict';

var
  Backbone = require('backbone'),
  config = require('../../../js/config'),
  mediator = require('../../../js/mediator'),
  $global   = require('../../../js/globalElements');

var MinimalHeaderView = Backbone.View.extend({
  scrollPosition: 0,
  animationDuration: 250,
  searchBarVisible: true,
  animateSearchBar: false,
  initialize: function() {
    this.searchBarEl = this.$el.find('div.Header-search');
    this.calculateScrollableHeight();
    mediator.on(config.events.ui.resize, this.onResize, this);
    mediator.on(config.events.ui.scrollThrottle, this.handleScroll, this);
    this.onResize();
  },
  handleScroll: function() {
    var currentScrollPos = $global.$window.scrollTop();
    if ((currentScrollPos < 0) ||
      (currentScrollPos >= this.scrollableHeight) ||
      (!this.animateSearchBar)) {
      this.scrollPosition = (currentScrollPos < 0 ? 0 :
        (currentScrollPos > this.scrollableHeight ? this.scrollableHeight : currentScrollPos));
      return;
    }
    var scrollDelta = currentScrollPos - this.scrollPosition;
    let visibleClass = 'Header-search--visible';
    if ((scrollDelta < 0 && !this.searchBarVisible) || currentScrollPos === 0) {
      this.searchBarEl.addClass(visibleClass);
      $global.$body.removeClass(config.classes.hasMobileMinimisedHeader);
      this.searchBarVisible = true;
    } else if (scrollDelta > 0 && this.searchBarVisible && this.scrollPosition > 0) {
      this.searchBarEl.removeClass(visibleClass);
      $global.$body.addClass(config.classes.hasMobileMinimisedHeader);
      this.searchBarVisible = false;
    }
    this.scrollPosition = currentScrollPos;
  },
  calculateScrollableHeight: function() {
    this.scrollableHeight = $global.$body.innerHeight() - $global.$window.innerHeight();
  },
  onResize: function() {
    this.calculateScrollableHeight();
    this.scrollPosition = $global.$window.scrollTop();
    if (this.animateSearchBar !== window.innerWidth < config.breakpoints.laptop) {
      this.searchBarVisible = true;
      // Clearing up residual inline styling from the animation.
      this.searchBarEl.css('display', '');
      this.animateSearchBar = !this.animateSearchBar;
      $global.$body.removeClass(config.classes.hasMobileMinimisedHeader);
    }
  }
});

module.exports = MinimalHeaderView;



// WEBPACK FOOTER //
// ./assets/components/Header/js/MinimalHeaderView.js